import { ModalToConfirm } from 'components/ModalWindows/ModalToConfirm';
import EditScheduleModal from './EditScheduleModal/EditScheduleModal';
import EditScheduleState from './EditScheduleModal/editScheduleModalContext/editScheduleModalState/EditScheduleModalState';
import CreateScheduleModal from './CreateScheduleModal/CreateScheduleModal';
import CreateScheduleState from './CreateScheduleModal/createScheduleModalContext/createScheduleModalState/CreateScheduleModalState';
import {
	IScheduleViewContext,
	ScheduleViewContext,
} from '../../scheduleViewContext/scheduleViewState/scheduleViewContext';
import React, { useContext, useCallback } from 'react';
import ModalSentSuccessfully from 'components/ModalWindows/ModalSentSuccessfully';
import ModalSentError from 'components/ModalWindows/ModalSentError';
import classNames from 'classnames';
import style from './ModalWindows.module.scss';

const ModalWindows: React.FC = () => {
	const { deleteSelectedItem, changeTypeOfModalWindow, typeOfModalWindow } =
		useContext<IScheduleViewContext>(ScheduleViewContext);

	const containerClasses = classNames(style.container, { [style.visible]: typeOfModalWindow });

	const handleChangeTypeOfModalWindow = useCallback(() => changeTypeOfModalWindow(null), [changeTypeOfModalWindow]);

	return (
		<div className={containerClasses} data-test="ModalWindows">
			<ModalToConfirm
				onConsentEvent={deleteSelectedItem}
				onFailureEvent={handleChangeTypeOfModalWindow}
				isVisible={typeOfModalWindow === 'toConfirmDeleteItem'}
				description="deleteSchedule"
				typeOfInfoIcon="toDelete"
			/>
			<ModalSentSuccessfully
				onConsentEvent={handleChangeTypeOfModalWindow}
				isVisible={typeOfModalWindow === 'success'}
				description="deleteScheduleSuccessfully"
			/>
			<ModalSentError
				onConsentEvent={handleChangeTypeOfModalWindow}
				isVisible={typeOfModalWindow === 'error'}
				description="errorWhileDeletingSchedule"
			/>
			<CreateScheduleState>
				<CreateScheduleModal
					isVisible={typeOfModalWindow === 'createSchedule'}
					onFailureEvent={handleChangeTypeOfModalWindow}
				/>
			</CreateScheduleState>
			<EditScheduleState>
				<EditScheduleModal
					isVisible={typeOfModalWindow === 'editSchedule'}
					onFailureEvent={handleChangeTypeOfModalWindow}
				/>
			</EditScheduleState>
		</div>
	);
};

export default ModalWindows;
